export default __webpack_public_path__ + "static/media/close-eye.cfa99ff1.svg";